import React, { Component } from 'react';
import { components, models } from '@kurtosys/ksys-app-components';
import { inject, observer } from 'mobx-react';

import { InjectedStyledComponent } from '../shared/InjectedStyledComponent.js';

import Wrapper from './styledComponents/Wrapper.js';
import { ICapabilitiesProps, ICapabilitiesState } from './models';

const Pill = components.base.Pill.Pill;

class RawCapabilities extends Component<ICapabilitiesProps, ICapabilitiesState> {
	static configurationKey = 'capabilities' as const;
	static styleKey = 'capabilities' as const;

	constructor(props: ICapabilitiesProps) {
		super(props);
	}

	render() {
		const { className, capabilitiesStore } = this.props;

		if (!capabilitiesStore) {
			return null;
		}

		const { capabilities } = capabilitiesStore;

		return (
			<Wrapper className={className}>
				{(capabilities || []).map((capability, capabilityIndex) => {
					const priority: models.TPriority = capabilityIndex === 0 ? 'primary' : 'none';
					return <Pill key={`${capability}_${capabilityIndex}`} value={capability} priority={priority} />;
				})}
			</Wrapper>
		);
	}
}

export const Capabilities = inject('appStore', 'capabilitiesStore')(observer(RawCapabilities));
export default InjectedStyledComponent(Capabilities, 'capabilities');
